import React, { useState } from "react";
import { Box, Stack } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { PagePaper } from "@/components/Paper/PagePaper";
import { PageTitle } from "@/components/Title";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { DesignListGrid } from "@/features/dmManagement/components/DesignListGrid";
import { StatusFilter } from "@/features/dmManagement/components/StatusFilter";
import { DESIGN_STATUS_OPTIONS } from "@/features/dmManagement/types/constants";
import { useDesigns } from "@/features/dmManagement/hooks/useDesigns";
import { useRefreshCooldown } from "@/features/dmManagement/hooks/useRefreshCooldown";
import { Button, ButtonVariantOption } from "@/components/Button";
import { LinkButton } from "@/components/Button/LinkButton";
import { SizingWrapperStyle } from "@/components/Wrapper";

export const DesignListPage: React.FC = () => {
  const [statusFilter, setStatusFilter] = useState("");
  const { designs, isLoading, mutate } = useDesigns(
    statusFilter ? { status: statusFilter } : undefined
  );
  const { coolDownTime, handleRefresh } = useRefreshCooldown(() => {
    void mutate();
  });

  return (
    <PagePaper>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ContactMailIcon sx={{ mr: 1 }} fontSize="large" />
          <PageTitle>デザインデータ管理</PageTitle>
          <Box sx={{ ml: 3 }}>
            {coolDownTime ? (
              <Button
                label={`残り${coolDownTime}秒`}
                onClick={handleRefresh}
                variant={ButtonVariantOption.Outlined}
                disabled
                size={SizingWrapperStyle.INHERIT}
              />
            ) : (
              <Button
                label="更新"
                onClick={handleRefresh}
                variant={ButtonVariantOption.Outlined}
                startIcon={<RefreshIcon />}
                size={SizingWrapperStyle.INHERIT}
              />
            )}
          </Box>
        </Box>
        <Stack direction="row" spacing={1}>
          <LinkButton
            variant={ButtonVariantOption.Outlined}
            href="/dmManagement"
            wrapperSize={SizingWrapperStyle.INHERIT}
          >
            DM管理に戻る
          </LinkButton>
          <LinkButton
            variant={ButtonVariantOption.Contained}
            href="/dmManagement/designs/new"
            wrapperSize={SizingWrapperStyle.INHERIT}
          >
            新規登録
          </LinkButton>
        </Stack>
      </Stack>
      <Box mb={2}>
        <StatusFilter
          value={statusFilter}
          onChange={setStatusFilter}
          options={DESIGN_STATUS_OPTIONS}
          labelId="design-status-filter-label"
        />
      </Box>
      <DesignListGrid
        designs={designs ?? []}
        isLoading={isLoading}
        mutate={mutate}
      />
    </PagePaper>
  );
};
